const { fontExceptionsLanguageList } = require('LoadConfig');
const PSEvents = require('PSEvents');
const PSConfig = require('PSConfig');

const LocaleLabelResponsiveOptions = cc.Class({
    name: 'LocaleLabelResponsiveOptions',
    properties: {
        // if aspectratio is >= to the value it will use current options
        // 0 will apply to all. useful for setting specific dimensions for a language
        aspectRatio: 0,
        position: cc.Vec2,
        width: 0,
        height: 0,
        scale: 1
    }
})

const LocaleLabelOption = cc.Class({
    name: 'LocaleLabelOption',
    properties: {
        // 'zz' value will apply to all languages
        lang: cc.String,
        fontSize: cc.Integer,
        font: cc.Font,
        lineHeight: cc.Integer,
        localeLabelResponsiveOptions: [LocaleLabelResponsiveOptions]
    }
})

cc.Class({
    extends: cc.Component,

    properties: {
        options: [LocaleLabelOption]
    },

    editor: {
        requireComponent: cc.Label,
    },

    onLoad () {
        this.label = this.getComponent(cc.Label);

        PSEvents.onEngineInitialized(() => {
            const { language } = PSConfig.get();
            let option = this.options.find(o => {
                const langs = o.lang.split(',');
                return langs.includes(language);
            });

            if (!option) {
                option = this.options.find(o => {
                    const langs = o.lang.split(',');
                    return langs.includes('zz');
                });
            }

            this.option = option;
            if (this.option) {
                this.applyValues();

                if (this.option.localeLabelResponsiveOptions.length > 0) {
                    this.option.localeLabelResponsiveOptions.sort((a, b) => a - b);

                    this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');

                    if (this.resizeManager) {
                        this.resizeManager.appendNode(this);

                        const { scaleRatio, aspectRatio  } = this.resizeManager;
                        this.onViewResize(scaleRatio, aspectRatio);
                    } else {
                        cc.warn('ResizeManager not found. required by component');
                    }
                }
            }
        });
    },

    onDestroy() {
        if(this.resizeManager) {
            this.resizeManager.removeNode(this);
        }
    },

    applyValues() {
        if (!this.label) {
            cc.warn('no label is referenced')
            return;
        }

        this.label.fontSize = this.option.fontSize || this.label.fontSize;
        this.label.font = this.option.font || this.label.font;
        this.label.lineHeight = this.option.lineHeight || this.label.lineHeight;
    },

    onViewResize (screenRatio, aspectRatio) {
        const { localeLabelResponsiveOptions } = this.option;

        let scale = 1;
        for(let i = 0; i < localeLabelResponsiveOptions.length; i++) {
            const data = localeLabelResponsiveOptions[i];

            if (aspectRatio >= data.aspectRatio) {
                this.label.node.width = data.width;
                this.label.node.height = data.height;
                this.label.node.scale = data.scale;
                this.label.node.position = data.position || this.label.node.position;
                break;
            }
        }
    },
});
